import { Button } from '@simplywallst/ui-core/next';
import CopyLink from '@assets/images/narrative/copy-link.svg';
import { useClipboard } from '@/hooks/useClipboard';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import CheckSolid from '@simplywallst/ui-core/icons/CheckSolid';
import { SWS_HOST } from '@/constants';
import { useTracking } from 'react-tracking';

type Props = {
  pathname: string;
};

export const NarrativeUpdateShare = ({ pathname }: Props) => {
  const { copy, isCopied } = useClipboard();
  const { isMobile, isTablet } = useUserAgent();
  const { trackEvent } = useTracking();
  const device =
    RUNTIME_ENV === 'native'
      ? 'native'
      : isMobile || isTablet
        ? 'mobile'
        : 'web';
  const utmQueryParams = `utm_source=share&utm_medium=${device}`;

  const sharePath = `${pathname}?${utmQueryParams}`;

  return (
    <Button
      variant="outline"
      onClick={() => {
        copy(`${SWS_HOST}${sharePath}`);
        trackEvent({
          action: 'click',
          modifier: 'share',
        });
      }}
      isDisabled={isCopied}
      size="medium"
    >
      {isCopied ? (
        <>
          <CheckSolid />
          Copied
        </>
      ) : (
        <>
          <CopyLink aria-label="Share" />
          Share
        </>
      )}
    </Button>
  );
};
